import React, { useCallback, useLayoutEffect } from 'react'
import { useSpring, animated, config } from '@react-spring/web'
import styled from 'styled-components'
import { Box, Flex } from '../../UI'
const Hamburger = styled(Flex)`
  background: none;
`
const Line = styled(animated.span)`
  display: block;
  position: absolute;
  width: 30px;
  height: 3px;
  border-radius: 2px;
  /* position: absolute; */
  background-color: #fff;
  &:before {
    content: '';
  }
`
const MenuToggle = ({ open, onClick }) => {
  const initialConfig = React.useMemo(
    () => ({
      top: [0, 3, 0, 0, 0, 0],
      center: [0, 13.5, 0, 0],
      bottom: [0, 24, 0, 0],
    }),
    []
  )

  const openConfig = React.useMemo(
    () => ({
      bottom: [0, 15, 0, -45],
      top: [0, 15, 0, 150, 0, 45],
      center: [0, 15, 0, 45],
    }),
    []
  )

  const [{ bottom }, bottomApi] = useSpring(() => ({
    bottom: [0, 24, 0, 0],
    delay: 100,
  }))

  const [{ top }, topApi] = useSpring(() => ({
    top: [0, 3, 0, 0, 0, 0],
    config: config.gentle,
    delay: 0,
  }))

  const [{ center }, centerApi] = useSpring(() => ({
    center: [0, 13.5, 0, 0],
    config: config.gentle,
    delay: 50,
  }))

  const setInitStyles = React.useCallback(
    (immediate) => {
      const init = immediate
        ? {
            immediate: true,
            ...initialConfig,
          }
        : initialConfig
      bottomApi.start(init)
      topApi.start(init)
      centerApi.start(init)
    },
    [bottomApi, centerApi, initialConfig, topApi]
  )

  const setOpenStyles = useCallback(() => {
    bottomApi.start(openConfig)
    topApi.start(openConfig)
    centerApi.start(openConfig)
  }, [bottomApi, centerApi, openConfig, topApi])

  const stopAnimations = useCallback(() => {
    centerApi.stop()
    topApi.stop()
    bottomApi.stop()
  }, [bottomApi, centerApi, topApi])

  useLayoutEffect(() => {
    open ? setOpenStyles() : setInitStyles()
  }, [open, setInitStyles, setOpenStyles])
  // stop animation on unmount (link pressed)
  useLayoutEffect(() => {
    setInitStyles(true)
    return () => {
      stopAnimations()
    }
  }, [setInitStyles, stopAnimations])

  // const openedTransformationConfig = {
  //   top: [0, 3, 0, 0, 0, 0],
  //   center: [0, 13.5, 0, 0],
  //   bottom: [0, 24, 0, 0],
  // }

  return (
    <Hamburger
      align="center"
      onClick={onClick}
      bg={'transparent'}
      color={'white'}
      as="button"
      style={{ border: 'none' }}
      fontSize={1}
      mx={1}
      p={0}
      // width={45}
      // height={45}
      aria-label="Toggle site menu"
      aria-haspopup="true"
      aria-expanded={open}
    >
      <Box display={'block'} position={'relative'} width={30} height={30}>
        <Line
          style={{
            transform: top.to(
              (x, y, z, p, ry, r) =>
                `translate3d(${x}px,${y}px,${z}px) perspective(${p}px) rotateY(${ry}deg) rotate(${r}deg)`
            ),
          }}
        />
        <Line
          style={{
            transform: center.to(
              (x, y, z, r) =>
                `translate3d(${x}px,${y}px,${z}px) rotate(${r}deg)`
            ),
          }}
        />
        <Line
          style={{
            transform: bottom.to(
              (x, y, z, r) =>
                `translate3d(${x}px,${y}px,${z}px) rotate(${r}deg)`
            ),
          }}
        />
      </Box>
    </Hamburger>
  )
}

export default MenuToggle
